"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WalkInRequestStruct = void 0;
const superstruct_1 = require("superstruct");
const types_1 = require("../types");
const formData_1 = require("../types/formData");
const BookAppointmentRequest_1 = require("./BookAppointmentRequest");
exports.WalkInRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    queueId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    serviceId: (0, superstruct_1.string)(),
    pushToken: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    order: (0, superstruct_1.optional)(BookAppointmentRequest_1.BookAppoinmentRequestOrderStruct),
    formData: (0, superstruct_1.optional)(formData_1.FormDataStruct),
    contactData: types_1.ContactDataStruct,
    preferredLanguage: (0, superstruct_1.optional)(types_1.LocaleLongStruct),
    createdFrom: (0, superstruct_1.enums)(['visitor', 'counter', 'kiosk']),
    kioskCode: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    counterId: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
//# sourceMappingURL=WalkInRequest.js.map